import React, { FC } from 'react';

import { Box, Image } from '@chakra-ui/react';

import InputParameters from './InputParameters.png';

export const GetInputParameters: FC = () => {
  return (
    <Box>
      <Image src={InputParameters} />
    </Box>
  );
};
